import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  listLimit,
  getDisabledData,
  getEmployeeCountText,
  DISABLED_GRAPHS,
} from '../../../../shared/util/companyReport';
import TopSixGraph from '../../components/graphs/topSixGraph/TopSixGraph';

function BehaviourChange({ data, coData, onOpenModal, graphLimit }) {
  const { t } = useTranslation();
  const { goals, selectedGoals } = data;

  const { showOldFocus, goalsCounter, selectedGoalsCounter } = coData;

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <>
      <TopSixGraph
        title={t('BC004')}
        square
        preText={
          selectedGoalsCounter >= graphLimit ? getEmployeeCountText(selectedGoalsCounter) : ''
        }
        data={
          selectedGoals.length < listLimit || selectedGoalsCounter < graphLimit
            ? getDisabledData(DISABLED_GRAPHS.GOALS)
            : selectedGoals
        }
        modalText={t('focus.graph.info')}
        onOpenModal={onOpenModal}
        disabled={selectedGoals.length < listLimit || selectedGoalsCounter < graphLimit}
      />
      {showOldFocus && goals.length >= listLimit && (
        <TopSixGraph
          title={t('BC015')}
          square
          preText={goalsCounter >= graphLimit ? getEmployeeCountText(goalsCounter) : ''}
          data={
            goals.length < listLimit || goalsCounter < graphLimit
              ? getDisabledData(DISABLED_GRAPHS.GOALS)
              : goals
          }
          modalText={t('focus.legacy.graph.info')}
          onOpenModal={onOpenModal}
          disabled={goals.length < listLimit || goalsCounter < graphLimit}
        />
      )}
    </>
  );
}
export default BehaviourChange;
